import React from "react";
import { Modal, Alert, Button } from "react-bootstrap";
import { reduxForm, Field, getFormValues } from "redux-form";
import { SimpleField, WideField, UnstiledField } from "../../common/Inputs";
import { AddressEdit } from "../../common/AddressEdit";
import { PhoneInput } from '../../common/PhoneInput';
import * as fetchingState from '../../../constants/fetchingState';
import { connect } from "react-redux";
import { departments } from '../../../constants/settingTypes';
import { DropdownListField } from '../../common/Inputs';
import { dcDepartmentTypes, RECEIVING_POINT } from '../../../constants/dcDepartmentTypes';
import { fetchAddresses as fetchAddressesAction } from '../../../actions/addresses';
import { fetchActiveAgents } from "../../../actions/agents";
import { parsePhoneNumber, required as phoneRequired, validate as validatePhone } from '../../../extensions/phoneHelper';
import { TimeInput } from '../../common/TimeInput';
import { MultiSelectField } from '../../common/Inputs';
import * as weekDays from '../../../constants/weekDays';
import { Row, Col, Grid } from 'react-bootstrap';
import moment from "moment";

const validate = (values, props) => {
    const errors = {};
    const required = type => {
        if (!values[type] || values[type].length === 0) {
            errors[type] = '*Обязательно для заполнения';
        }
    }

    required('Address');
    required('FullName');

    if (values.StartWorkTime > values.EndWorkTime)
        errors.StartWorkTime = '*Время начала дня не может быть больше времени конца';
    if (values.Address && !values.GeoAddress)
        errors.Address = '*Некорректный адрес';
    if (values.AddressError)
        errors.Address = values.AddressError;
    if (!/[0-9]\.+[0-9]+,\s*[0-9]+\.[0-9]+/.test(values.Coords)) {
        errors.Coords = '*Неверный формат координат';
    }
    const days = ["Monday", "Tuesday", "Wesnesday", "Thursday", "Friday", "Saturday", "Sunday"];
        days.forEach(day => {
            if (values[day]) {
                const { StartTime, EndTime } = values[day];
                errors[day] = {};

                if (StartTime > EndTime) {
                    errors[day].StartTime = "*Время начала дня не может быть больше времени конца";
                }
                if ((StartTime && !EndTime) || (!StartTime && EndTime)) {
                    errors[day].StartTime = "*Оба поля времени должны быть заполнены";
                    errors[day].EndTime = "*Оба поля времени должны быть заполнены";
                }

                if (!Object.keys(errors[day]).length) {
                    delete errors[day];
                }
            }
        });
    const { Phone } = values;
    if (props.initialValues.Phone === Phone)
        return errors;

    const phoneError = phoneRequired(Phone) || validatePhone(Phone);
    if (phoneError)
        errors.Phone = phoneError;
    return errors;
}

let EditModal = class extends React.Component {
    constructor(props) {
        super(props);
        this._onSubmit = this._onSubmit.bind(this);
        this._fetchAddress = this._fetchAddress.bind(this);
    }

    componentDidMount() {
        this.props.fetchActiveAgents();
    }

    _onSubmit(values) {
        const model = {...values};
        model.Phone = parsePhoneNumber(values.Phone);
        
        if (values.Type == RECEIVING_POINT) {

                const days = {
                Monday: 1,
                Tuesday: 2,
                Wesnesday: 4,
                Thursday: 8,
                Friday: 16,
                Saturday: 32,
                Sunday: 64,
            };

            const parseTime = (timeString) => {
        if (!timeString) return null;
        const timeParts = timeString.includes('T') 
            ? timeString.split('T')[1].split(':') 
            : timeString.split(':');

        return timeParts.length < 2 
            ? null 
            : { hours: Number(timeParts[0]), minutes: Number(timeParts[1]) };
    };

    const timeZoneOffset = new Date().getTimezoneOffset() / 60;
               Object.keys(days).forEach(day => {
                if (!model[day]) {
                    model[day] = { Day: days[day], StartTime: null, EndTime: null };
                } else {
                    if (!model[day].Day) {
                        model[day].Day = days[day];
                    }

                    const startTime = parseTime(model[day].StartTime);
                    const endTime = parseTime(model[day].EndTime);

                    if (startTime) {
                        model[day].StartTime = moment()
                            .set('hour', startTime.hours + timeZoneOffset)
                            .set('minute', startTime.minutes)
                            .set('second', 0)
                            .format('HH:mm:ss');
                    }

                    if (endTime) {
                        model[day].EndTime = moment()
                            .set('hour', endTime.hours + timeZoneOffset)
                            .set('minute', endTime.minutes)
                            .set('second', 0)
                            .format('HH:mm:ss');
                    }
                }
            });

            const coordsComponents = values.Coords.replace(/\s/g, '').split(',');
            model.GeoAddress = {
                Y: coordsComponents[0],
                X: coordsComponents[1]
            };
        }
        this.props.onSubmit(model);
    }

    _fetchAddress(term) {
        this.props.fetchAddressesAction(term);
    }

    render() {
        const {
            fetching,
            agents,
            agentsFetching,
            onClose,
            handleSubmit,
            anyTouched,
            error,
            change,
            isNew,
            fetchedAddresses,
            fetchAddressesAction,
            pristine,
            formValues,
            crudError } = this.props;

        const formVisible = fetching === fetchingState.INITIAL && agentsFetching === fetchingState.FETCHED;
        const closeButtonVisible = fetching === fetchingState.FETCHED || fetching === fetchingState.FAILED;
        const isReceivingPoint = formValues && formValues.Type != null && (formValues.Type == RECEIVING_POINT || (formValues.Type.Id != null && formValues.Type.Id == RECEIVING_POINT));

        const renderWorkDayFields = () => {
            const days = weekDays.days

            return (
                <Grid fluid>
                    {days.map(day => (
                        <Row key={day.name}>
                            <Col md={3}>
                                <label>{day.label}</label>
                            </Col>
                            <Col md={3}>
                                <Field name={`${day.name}.Day`} component="input" type="hidden" value={day.value} />
                                <Field name={`${day.name}.StartTime`} component={TimeInput} label="Начало" />
                            </Col>
                            <Col md={3}>
                                <Field name={`${day.name}.EndTime`} component={TimeInput} label="Конец" />
                            </Col>
                        </Row>
                    ))}
                </Grid>
            );
        };

        const renderCoordsFields = () => {
            return(
                <div className="row" style={{margin: '5px'}}>
                    <Field name="Coords" component={UnstiledField} label='Координаты' isHorisontal />
                </div>
            );
        }

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{isNew ? 'Новый отдел' : 'Редактирование отдела'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formVisible && <form className='form-horizontal'>
                        {!isReceivingPoint && <AddressEdit geoAddressName='GeoAddress'
                            change={change}
                            fetchAddressesAction={fetchAddressesAction}
                            fetchedAddresses={fetchedAddresses} showAdditionalFields={true} />}
                        {isReceivingPoint && renderCoordsFields()}

                        <Field name='FullName' component={SimpleField} label={isReceivingPoint ? 'Название' : 'ФИО'} />
                        <Field name='Type' component={DropdownListField} data={dcDepartmentTypes}
                            valueField='Id' textField='Name' label='Тип отдела' normalize={(v, pv) => v == null ? pv : v.Id} />
                        <Field name='Phone' component={PhoneInput} label='Телефон' />
                        <Field name='AgentId' component={DropdownListField} label='Агент'
                            data={agents} valueField='Id' textField='Name' normalize={(v, pv) => v ? v.Id : pv} />
                        {isReceivingPoint && <Field name='CardLink' component={SimpleField} label='Карточка точки' />}
                        {isReceivingPoint == true && renderWorkDayFields()}
                        <Field name='IsActive' component={WideField} label='Действует?' type='checkbox' />

                        {anyTouched && error && <strong style={{ color: 'red', marginLeft: '5px' }}>{error}</strong>}
                    </form>}
                    {fetching === fetchingState.FETCHING || agentsFetching === fetchingState.FETCHING &&
                        <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                    {fetching === fetchingState.FETCHED &&
                        <Alert bsStyle='success'>УСПЕХ!</Alert>}
                    {fetching === fetchingState.FAILED &&
                        <Alert bsStyle='danger'>
                        <p>ОШИБКА!</p>
                        {crudError && <p>{crudError}</p>}
                    </Alert>}
                    {agentsFetching === fetchingState.FAILED &&
                        <Alert bsStyle='danger'>Ошибка загрузки активных агентов.</Alert>}
                </Modal.Body>
                {formVisible && <Modal.Footer>
                    <Button bsStyle="success" type="submit" onClick={handleSubmit(this._onSubmit)} disabled={pristine}>Сохранить</Button>
                    <Button type="button" onClick={onClose}>Отмена</Button>
                </Modal.Footer>}
                {closeButtonVisible &&
                    <Modal.Footer>
                        <Button type="button" onClick={onClose}>
                            Закрыть
                        </Button>
                    </Modal.Footer>}
            </Modal>
        );
    }
}

EditModal = reduxForm({
    form: 'departmentEdit',
    validate,
    getFormValues
})(EditModal);

EditModal = connect((state, props) => {
    return {
        fetching: state.application.get('settings')[departments].updateFetching,
        agents: state.application.get('settings').agents.active,
        agentsFetching: state.application.get('settings').agents.activeFetching,
        fetchedAddresses: state.application.get('addresses'),
        formValues: getFormValues('departmentEdit')(state),
        crudError: state.application.get('settings')[departments].updateError
    }
}, { fetchAddressesAction, fetchActiveAgents })(EditModal);

export default EditModal;


// WEBPACK FOOTER //
// ./src/components/settings/departments/EditModal.jsx